import { type InputInputSlotProps } from '@mui/base'
import { type FC } from 'react'

import { Rating } from 'base-ui'

import { TosSuperscriptHowProductRatingCalculated } from '../../../tos-superscripts'

import styles from './ProductSearchRefinementRatingInputRating.module.css'

export const ProductSearchRefinementRatingInputRating: FC<
  InputInputSlotProps
> = (props) => {
  return (
    <div className={styles['product-search-refinement-rating-input-rating']}>
      <Rating {...props} />
      <TosSuperscriptHowProductRatingCalculated className="ml-1 text-xs text-dark-primary-strong" />
    </div>
  )
}
